<template>
  <div>
    <div class="loginBanner" v-show="isEnv">
      <label> 账户：<input type="text" v-model="username" /> </label>
      <label> 密码：<input type="password" v-model="password" /> </label>
      <button @click="loginFn">普通登录</button>
      <button @click="loginFn2">专有钉钉登录</button>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/zdqd.js'
import { Toast } from 'vant'
import dd from 'gdt-jsapi'
import crudUser from '../api/user'

export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      isEnv: false
    }
  },
  props: {},
  components: {},
  created() {
    this.isEnv = process.env.NODE_ENV !== 'production' ? true : false
    if (process.env.NODE_ENV == 'production') {
      let that = this
      if (sessionStorage.getItem('token')) return
      Toast.loading({
        duration: 0,
        mask: true,
        message: '登录中...',
        forbidClick: true
      })
      dd.ready(() => {
        dd.getAuthCode({}).then(res => {
          crudUser.getInfo(res.code).then(res1 => {
            sessionStorage.setItem('token', res1.data.token)
            sessionStorage.setItem('accountid', res1.data.accountid)
            Toast.clear(true)
            that.$router.push('/')
          })
        })
      })
    }
  },
  mounted() {},
  methods: {
    loginFn() {
      login({
        username: this.username,
        password: this.password
      })
        .then(data => {
          sessionStorage.setItem('token', data.data.token)
          this.$router.replace('/')
        })
        .catch(err => {
          Toast('账号或密码错误')
        })
    },
    loginFn2() {
      dd.ready(() => {
        dd.getAuthCode({})
          .then(res => {
            crudUser.getInfo(res.code).then(res1 => {
              sessionStorage.setItem('token', res1.data.token)
              this.$router.replace('/')
            })
          })
          .catch(err => {})
      })
    }
  }
}
</script>

<style scoped>
.loginBanner {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: #e0e0e0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
}
.loginBanner input {
  margin: 10px 0;
}
.loginBanner button {
  width: 30%;
  height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue